var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "availability" } }, [
    _c("div", { staticClass: "material-icons time-icon" }, [
      _vm._v("calendar_today"),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "header", on: { click: _vm.changeVisible } }, [
        _c("div", { staticClass: "header-titles" }, [
          _c("span", { staticClass: "header-title" }, [
            _vm._v(_vm._s(_vm.$t("calendar.calendars"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "header-sub-title" }, [
            _vm._v(_vm._s(_vm.$t("calendar.calendarsDesc"))),
          ]),
        ]),
        _vm._v(" "),
        _vm.visible
          ? _c("div", { staticClass: "material-icons" }, [
              _vm._v("expand_less"),
            ])
          : _c("div", { staticClass: "material-icons" }, [
              _vm._v("expand_more"),
            ]),
      ]),
      _vm._v(" "),
      _vm.visible
        ? _c("div", [
            _c(
              "div",
              { staticClass: "calendar-list" },
              [
                _c(
                  "a-select",
                  {
                    staticClass: "select-calendar",
                    attrs: { "show-search": "" },
                    model: {
                      value: _vm.calendarData.calendarId,
                      callback: function ($$v) {
                        _vm.$set(_vm.calendarData, "calendarId", $$v)
                      },
                      expression: "calendarData.calendarId",
                    },
                  },
                  _vm._l(_vm.calendars, function (calendar, i) {
                    return _c(
                      "a-select-option",
                      { key: i, attrs: { value: calendar._id } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(calendar.summary) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.availabilityCalendars, function (calendar) {
                  return _c("div", { staticClass: "calendar-item" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: calendar.isSelected,
                          expression: "calendar.isSelected",
                        },
                      ],
                      staticClass: "item-checkbox",
                      attrs: {
                        type: "checkbox",
                        disabled: _vm.isDisabled(calendar),
                      },
                      domProps: {
                        checked: Array.isArray(calendar.isSelected)
                          ? _vm._i(calendar.isSelected, null) > -1
                          : calendar.isSelected,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.changeSelectedCalenderIds(calendar)
                        },
                        change: function ($event) {
                          var $$a = calendar.isSelected,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  calendar,
                                  "isSelected",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  calendar,
                                  "isSelected",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(calendar, "isSelected", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(calendar.summary))]),
                  ])
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }